<template>
<div class="vpn-home">
  <HeadNav selected-language="en" page="home" />
  <main>
    <HomeSections />
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss'
import '@/css/vpn-sections.scss'
import HeadNav from '@/components/HeadNav.vue'
import HomeSections from '@/components/myvpnbook/HomeSections.vue'

export default {
  name: 'Home',
  components: { HeadNav, HomeSections },
  mounted() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('vpn-site')
    }
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('vpn-site')
    }
  },
}
</script>
